import { MessageContextMap } from "@shared";
import { createSetStore } from "./setStore";
function createUnconfirmedReadByThemStore() {
    return createSetStore();
}
export const unconfirmedReadByThem = createUnconfirmedReadByThemStore();
